<template>
  <div v-if="applicant && applicant.blocked" class="applicant-block-banner" dir="rtl" role="alert" data-test="block-banner" @click.stop>
    <p class="banner-main" data-test="block-banner-main">{{ mainText }}</p>
    <p v-if="cvText" class="banner-cv" data-test="block-banner-cv">{{ cvText }}</p>
    <button
      v-if="block.can_unblock"
      class="button is-small is-danger is-outlined banner-release"
      :class="{ 'is-loading': releasing }"
      :disabled="releasing"
      data-test="block-banner-release"
      @click.stop="release"
    >הסרת חסימה (מנהל/ת)</button>
  </div>
</template>

<script>
import { formatBlockDate, cvStatusText, askReason, releaseErrorText } from '@/custom/helpers/applicant_block.js'

// Red notice shown wherever a blocked applicant's json is on screen. All text is rendered
// with interpolation (escaped) - the reason is free text typed by an admin, never v-html.
export default {
  name: 'ApplicantBlockBanner',
  props: {
    applicant: { type: Object, default: null }
  },
  data () {
    return { releasing: false }
  },
  computed: {
    block () {
      return (this.applicant && this.applicant.block) || {}
    },
    mainText () {
      const by = this.block.by && this.block.by.name ? ` נחסם/ה ע"י ${this.block.by.name}` : ' נחסם/ה'
      const at = formatBlockDate(this.block.at)
      const reason = this.block.reason ? ` סיבה: ${this.block.reason}` : ''
      return `⛔ המועמד/ת חסום/ה — אין להגיש למעסיקים ואין ליצור קשר.${by}${at ? ' ב-' + at : ''}.${reason}`
    },
    cvText () {
      return cvStatusText(this.block.cv_erasure_status)
    }
  },
  methods: {
    emitToast (text, type) {
      this.$utils.emit('show_toast', { text, type })
    },
    async release () {
      if (this.releasing || !this.block.can_unblock) return
      if (!this.block.blocklist_id) {
        this.emitToast('הסרת החסימה נכשלה - חסר מזהה חסימה, יש לרענן', 'error')
        return
      }
      const reason = askReason('סיבת הסרת החסימה (חובה):', t => this.emitToast(t, 'error'))
      if (!reason) return
      this.releasing = true
      try {
        const res = await this.$network_utils.releaseBlockedCandidate({ id: this.block.blocklist_id, reason })
        this.emitToast('החסימה הוסרה')
        this.$emit('released', res)
      } catch (error) {
        this.emitToast(releaseErrorText(error), 'error')
      } finally {
        this.releasing = false
      }
    }
  }
}
</script>

<style scoped>
.applicant-block-banner {
  background: #fdecea;
  border: 1px solid #e0b4b0;
  border-right: 5px solid #c0392b;
  border-radius: 6px;
  color: #922b21;
  padding: 10px 14px;
  margin-bottom: 10px;
  text-align: right;
  line-height: 1.6;
  white-space: normal;
  word-break: break-word;
}
.banner-main {
  font-weight: 700;
  font-size: 14px;
}
.banner-cv {
  font-size: 13px;
  margin-top: 2px;
}
.banner-release {
  margin-top: 8px;
}
</style>
